import React, { useEffect, useState } from 'react';

import { connect } from 'react-redux';

import { isEmpty, sortBy } from 'lodash';

import TextField from '@material-ui/core/TextField';
import AutoComplete from '@material-ui/lab/Autocomplete';
import CircularProgress from '@material-ui/core/CircularProgress';

import * as K2ACoreActions from '../actions/k2aCoreActions';

import * as classes from './BobClientSelector.module.css';

const BobClientSelector = ({
    fetchClients,
    companyId,
    clientList,
    disabled,
    value,
    errors,
    handleChange,
    touched,
    label,
    required,
    isFromRuleDebugger,
    isFromLegacyRuleDebugger,
    ...props
}) => {
    const [filteredClientList, setFilteredClientList] = useState([]);
    const [loading, setLoading] = useState(false);
    const [clientValue, setClientValue] = useState({});

    useEffect(() => {
        const init = async () => {
            setLoading(true);
            const list = await fetchClients(companyId, { limit: 1000 });
            setFilteredClientList(list);
            setLoading(false);
        };

        if (companyId && !isFromRuleDebugger && !isFromLegacyRuleDebugger) init();
    }, [companyId]);

    useEffect(() => {
        if (!isEmpty(clientList) && (isFromRuleDebugger || isFromLegacyRuleDebugger)) {
            setFilteredClientList(clientList);
        }
    }, [clientList]);

    useEffect(() => {
        setClientValue(value);
    }, [value]);

    return (
        <AutoComplete
            id="clientId"
            name="clientId"
            options={sortBy(filteredClientList, 'name')}
            getOptionLabel={(option) => option.name || ''}
            getOptionSelected={(option, value) => option && value ? option.name === value.name : ''}
            value={clientValue}
            onChange={(event, value) => handleChange(event, value)}
            size="small"
            disabled={disabled}
            required
            renderInput={(params) =>
                <TextField
                    {...params}
                    className={classes.Required}
                    label={label}
                    variant="outlined"
                    required={required}
                    error={errors ? true : false}
                    helperText={errors ? errors : null}
                    InputProps={{
                        ...params.InputProps,
                        endAdornment: (
                            <React.Fragment>
                                {loading ? <CircularProgress color="inherit" size={15} /> : null}
                                {params.InputProps.endAdornment}
                            </React.Fragment>
                        ),
                    }}
                />}
        />
    );
};

const mapDispatchToProps = {
    ...K2ACoreActions
};

export default connect(null, mapDispatchToProps)(BobClientSelector);
